import { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Gravatar from 'react-gravatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import useAuth from '../../hooks/useAuth'

const Box = styled.div`
  min-width: 200px;
  padding: 6px 0 6px 6px;
  text-transform: capitalize;
  color: var(--color-text-secondary);
  border: 2px solid var(--color-main-gray);
  border-radius: 4px;
  transition: border-color 0.2s ease;
  cursor: pointer;
  position: relative;

  display: grid;
  grid-template-columns: max-content 1fr max-content;
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 10px;
  align-items: center;

  &:hover {
    border-color: var(--color-primary);

    nav {
      color: var(--color-primary);
    }
  }
`

const StyledGravatar = styled(Gravatar)`
  grid-row: 1 / -1;

  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid var(--color-primary);
`

const Label = styled.h2`
  font-size: 16px;
  color: var(--color-text-primary);
  font-weight: 900;
`

const Heading = styled.h1`
  grid-row: 2 / -1;

  line-height: 1;
  font-size: 14px;
  font-weight: 400;
`
const Nav = styled.nav`
  margin-right: -1px;
  width: 48px;
  height: 100%;
  grid-row: 1 / -1;
  border-radius: 10px;
  margin-left: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text-secondary);
  transition: color 0.2s ease;
`

const Dropdown = styled.ul`
  position: absolute;
  top: calc(100% + 15px);
  left: 0;
  right: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  background-color: var(--color-bg-card);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 -2px 8px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid var(--color-border, rgba(255, 255, 255, 0.1));
  z-index: 1;
`

const Item = styled.li`
  white-space: nowrap;
  padding: 12px;
  text-transform: capitalize;
  cursor: pointer;
  color: var(--color-text-primary);
  background-color: var(--color-bg-card);
  transition: background-color 0.2s ease;

  &:first-of-type {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-of-type {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:first-of-type::after {
    content: '';
    width: 20px;
    height: 20px;
    clip-path: polygon(50% 50%, 0% 100%, 100% 100%);
    background-color: var(--color-bg-card);
    position: absolute;
    top: 0;
    right: 30px;
    transform: translateY(-95%);
    z-index: 1;
  }

  &:hover {
    background-color: var(--color-bg-sidebar);
  }

  &:first-of-type:hover::after {
    background-color: var(--color-bg-sidebar);
  }
`

const User = () => {
  const ref = useRef()
  const [showDropdown, setShowDropdown] = useState(false)
  const toggleDropdown = () => setShowDropdown(toggle => !toggle)

  const { user, isSuperAdmin, isOrgAdmin, logOut } = useAuth()
  const history = useHistory()

  const identity = {
    first: user['https://harbortrek10/users'].firstName,
    last: user['https://harbortrek10/users'].lastName,
    email: user.email,
  }
  const handleOutsideClick = e => {
    if (ref.current.contains(e.target)) return
    setShowDropdown(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
    // eslint-disable-next-line
  }, [])

  return (
    <Box ref={ref} onClick={toggleDropdown}>
      <StyledGravatar email={identity.email} default='mp' />
      <Label>
        {identity.first} {identity.last}
      </Label>
      <Heading>{isSuperAdmin || isOrgAdmin ? 'Admin' : 'User'}</Heading>
      <Nav>
        <FontAwesomeIcon icon={faAngleDown} size='lg' />
      </Nav>
      {showDropdown && (
        <Dropdown>
          <Item onClick={() => history.push(`/profile`)}>Edit Profile</Item>
          <Item onClick={() => history.push('/users')}>Users</Item>
          <Item onClick={logOut}>Log out</Item>
        </Dropdown>
      )}
    </Box>
  )
}

export default User
